import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { EmbedData } from '../../data/embed';
import { Subject, takeUntil } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { EmbedService } from '../../../../embed-layout/common/services/embed.service';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'edit-header',
  imports: [CommonModule, FormsModule, RouterModule, MatIconModule, MatButtonModule],
  templateUrl: './edit-header.component.html',
  styleUrl: './edit-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditHeaderComponent implements OnInit, OnDestroy {
  public isTitleChange: boolean = false;

  public embedData: EmbedData | undefined;

  private unsubscribeAll: Subject<any> = new Subject();

  constructor(
    private embedService: EmbedService,
    private cd: ChangeDetectorRef,
  ) {}

  //--------------------------------------------------------------------------------------------------------
  // @ Life Circle
  //--------------------------------------------------------------------------------------------------------

  ngOnInit(): void {
    this.getEmbedData();
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next(null);
    this.unsubscribeAll.complete();
    this.unsubscribeAll.unsubscribe();
  }

  //--------------------------------------------------------------------------------------------------------
  // @ Public Method
  //--------------------------------------------------------------------------------------------------------

  public onClickTitleChangeBtn(): void {
    this.isTitleChange = true;
    this.cd.markForCheck();
  }

  public onCompleteTitleChange(): void {
    this.isTitleChange = false;
    console.log('onCompleteTitleChange');
    this.embedService.embedData = this.embedData;
    this.embedService.updateEmbedData();
    this.cd.markForCheck();
  }

  //--------------------------------------------------------------------------------------------------------
  // @ Private Method
  //--------------------------------------------------------------------------------------------------------

  private getEmbedData(): void {
    this.embedService.embedData$
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe((embedData: EmbedData | undefined) => {
        if (!embedData) return;
        this.embedData = embedData;
        this.cd.markForCheck();
      });
  }
}
